// `Database.updateTask`'s mutation doesn't select the nested `itemCounter`
// block, so the task it returns has only `itemCounterId` -- but plenty of UI
// reads `task.itemCounter.name` (and the task detail page's quick-set buttons
// read `.counter`). This resolves the counter back onto a saved task:
//
//   1. the counter didn't change -> reuse the one we already had loaded,
//   2. look it up in the item's already-loaded counter list (no round-trip),
//   3. fetch it -- it may have been created in another tab/session after this
//      item loaded, so the in-memory list is stale,
//   4. placeholder, so UI reading `.name` doesn't crash when the counter was
//      genuinely deleted (or the fetch failed).
//
// Mutates and returns `savedTask`, the same way its callers already treat the
// object handed back from `updateTask`. Shared by the task edit popup
// (useEditTaskPopup) and the always-editable task detail page (Task.jsx).

import { retrieveCounter } from '../../utilities/Database.mjs';

export async function attachItemCounter(savedTask, previousTask, item) {
  if (savedTask.itemCounterId === previousTask?.itemCounterId) {
    savedTask.itemCounter = previousTask?.itemCounter;
    return savedTask;
  }

  let found = item?.itemCounter?.items
    ? item.itemCounter.items.find((counter) => counter.id === savedTask.itemCounterId)
    : null;

  if (!found && savedTask.itemCounterId) {
    try {
      found = await retrieveCounter(savedTask.itemCounterId);
    } catch {
      // Network/security error -- fall through to the placeholder below.
    }
  }

  savedTask.itemCounter = found || { name: 'Refresh the page' };
  return savedTask;
}

export default attachItemCounter;
